import './modal.scss';

import Modal, { type ModalProps } from 'antd/lib/modal';
import React, { type JSX } from 'react';

interface ChildrenArguments {
  classes: {
    actions: string;
    form: string;
  };
}

interface IProps extends Omit<ModalProps, 'children'> {
  onClose: () => void;
  children?: ((props: ChildrenArguments) => JSX.Element) | React.ReactNode;
}

const childrenClassNames: ChildrenArguments['classes'] = {
  actions: 'modal__actions',
  form: 'modal__form'
};

const CustomModal: React.FC<IProps> = ({ children, ...props }) => {
  return (
    <Modal
      centered
      mask={{
        closable: true
      }}
      {...props}
      className={`modal ${props.className ? props.className : ''}`}
      onCancel={props.onClose || props.onCancel}
      footer={<></>}
    >
      {typeof children === 'function'
        ? children?.({ classes: childrenClassNames })
        : children}
    </Modal>
  );
};

export default CustomModal;
